import React, { useState } from "react";
import { Box, Grid, Typography, Button, MenuItem } from "@mui/material";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/Latest Logo.png";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { GoLightBulb } from "react-icons/go";
import { RxHamburgerMenu } from "react-icons/rx";
import Fade from "react-reveal/Fade";
import { customTextColor } from "../../utils/const";

const DataBackUp = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Box>
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>
        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact us
            </b>
          </a>
          <Box className={styles.login_btn}>
            <a onClick={() => navigate("/login")}>
              <b>Login</b>
            </a>
          </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Home
              </Typography>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </Typography>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                About us
              </Typography>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Contact us
              </Typography>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "35px" }} id="home" />
      <Box className={styles.home_structure}>
        <Fade bottom delay={200}>
          <Box className={styles.configuration_structure}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={4}
                md={3}
                sx={{ backgroundColor: "#fff", border: "2px solid #f2f2f2" }}
              >
                <Box className={styles.security_body}>
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      color: customTextColor,
                      fontSize: "17px !important",
                      margin: "4px 0",
                    }}
                    onClick={() => navigate("/privacy-policy")}
                  >
                    <b>Privacy Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/refund-policy")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Refund Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/term-of-use")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Website Terms of Use</b>
                  </Box>
                </Box>

                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/data-backup-policy")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                     <b style={{ borderBottom: "2px solid #1991e0" }}>Data Backup Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/safe-job-search")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Safe Job Search & Applies Security </b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  onClick={() => navigate("/reporting-fraud")}
                  style={{ margin: "14px 0" }}
                >
                  <Box
                    aria-controls="panel3-content"
                    id="panel3-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Reporting fraud</b>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                md={9}
                style={{
                  paddingLeft: window.innerWidth < 600 ? "15px" : "0",
                }}
              >
                <Box
                  className={styles.employer_details}
                  sx={{ lineHeight: "2" }}
                >
                  {/* <Box className={styles.employer_details}> */}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      padding: "10px 30px 30px 20px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{ fontSize: "20px !important", userSelect: "none" }}
                      >
                        <b>Data Backup Policy</b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        By accessing or using Povital, you acknowledge and agree
                        to be bound by this Data Backup Policy. You are
                        responsible for all actions that are performed on or
                        through your Povital account, including any procurement
                        or use of third party products or services (and
                        associated disclosure of data) in connection with the
                        cloud product. If you have been added or invited to a
                        cloud product, the party that administers such cloud
                        product (and not you) controls your use of that cloud
                        product, including but not limited to adding or removing
                        You from that cloud product, enabling or disabling
                        third-party integrations, and managing permissions. Any
                        content that You submit or upload to the cloud product
                        may be retained, accessed, used, modified, shared, or
                        removed by the party that administers such cloud product
                        and their appointees. You acknowledge that your POVITAL
                        account is subject to the limited rights granted by You
                        hereunder, and We acquire no right, title, or interest
                        from You or Your licensors under this Agreement in or to
                        Your Data. This includes any intellectual property
                        rights therein.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Povital conducts regular data backups as part of its
                        service offering to clients to protect from data loss or
                        data migration. Povital also performs data enrichment
                        for clients for faster searches, quality search results,
                        and to provide data integrity using its advanced parser
                        algorithms to all active clients. We do not control,
                        retain, or have a title to store data from third-party
                        websites. The functionality is at the sole and express
                        choice of the customer, which are further detailed in
                        our Privacy Policy.
                      </Typography>
                    </Box>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Box>
      <Footer />
    </Box>
  );
};

export default DataBackUp;
